// extracted by mini-css-extract-plugin
export var container = "_61-0";
export var disabled = "_61-4";
export var fullWidth = "_61-3";
export var lined = "_61-1";
export var selected = "_61-5";
export var tab = "_61-2";